import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function Resist() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Resist Temptation When it Comes" />
        <p>React quickly and decisively to defeat temptation every time.</p>
        <blockquote>“Resist the devil and he will flee from you.” (James 4:7-8)</blockquote>
      </div>
    </PageLayout>
  );
};
